<template>
  <div class="reference-line">
    <div
      v-for="(item, i) of lines"
      class="line"
      :key="i"
      :style="{
        left: `${item.left}px`,
        top: `${item.top}px`,
        width: item.left === 0 ? '100%' : 'auto',
        height: item.top === 0 ? '100%' : 'auto'
      }"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    lines: {
      type: Array,
      default: []
    }
  }
};
</script>

<style lang="less" scoped>
.reference-line {
  .line {
    position: absolute;
    border: 0.5px dashed #2154f4;
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/HotSpot/components/ReferenceLine.vue